import {
	GLOBAL_CONFIG_LOADING,
	GLOBAL_CONFIG_GET,
	GLOBAL_CONFIG_ERROR,
	GLOBAL_CONFIG_CREATE_LOADING,
	GLOBAL_CONFIG_CREATE_SUCCESS,
	GLOBAL_CONFIG_CREATE_ERROR,
	GLOBAL_CONFIG_INFO_LOADING,
	GLOBAL_CONFIG_INFO,
	GLOBAL_CONFIG_INFO_ERROR,
	GLOBAL_CONFIG_GROUPS_LOADING,
	GLOBAL_CONFIG_GROUPS_GET,
	GLOBAL_CONFIG_GROUPS_ERROR,
	GLOBAL_CONFIG_GROUPS_CREATE_LOADING,
	GLOBAL_CONFIG_GROUPS_CREATE_SUCCESS,
	GLOBAL_CONFIG_GROUPS_CREATE_ERROR,
	SET_GLOBAL_CONFIG_GROUP_ID,
	GLOBAL_CONFIG_GROUPS_CHANGES,
	GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
	GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS,
	GLOBAL_CONFIG_FIELDS_CREATE_ERROR,
	GLOBAL_CONFIG_FIELDS_UPDATE_ERROR
} from '../actions/types';

const initialState = {
	global_config_loading: false,
	global_config: { count: 0, configurations: [] },
	global_config_create_loading: false,
	global_config_create_success: false,
	global_config_info_loading: false,
	global_config_info: {},
	global_config_groups_loading: true,
	global_config_groups: { count: 0, groups: [] },
	global_config_groups_create_loading: false,
	global_config_groups_create_success: false,
	global_config_group_id: null,
	global_config_groups_changes: {},
	global_config_fields_create_loading: false,
	global_config_fields_create_success: false,
	global_errors: {}
}

export default function globalReducer(state = initialState, action) {
	switch (action.type) {
		case GLOBAL_CONFIG_LOADING:
			return {
				...state,
				global_config_loading: action.payload
			}
		case GLOBAL_CONFIG_GET:
			delete state.global_errors.global_config
			return {
				...state,
				global_config: {
					count: action.payload.count,
					configurations: action.payload.configurations
				}
			}
		case GLOBAL_CONFIG_CREATE_LOADING:
			return {
				...state,
				global_config_create_loading: action.payload
			}
		case GLOBAL_CONFIG_CREATE_SUCCESS:
			return {
				...state,
				global_config_create_success: action.payload
			}
		case GLOBAL_CONFIG_INFO_LOADING:
			return {
				...state,
				global_config_info_loading: action.payload
			}
		case GLOBAL_CONFIG_INFO:
			delete state.global_errors.global_config_info
			return {
				...state,
				global_config_info: action.payload
			}
		case GLOBAL_CONFIG_GROUPS_LOADING:
			return {
				...state,
				global_config_groups_loading: action.payload
			}
		case GLOBAL_CONFIG_GROUPS_GET:
			delete state.global_errors.global_config_groups
			return {
				...state,
				global_config_groups: {
					count: action.payload.count,
					groups: action.payload.groups
				}
			}
		case GLOBAL_CONFIG_GROUPS_CREATE_LOADING:
			return {
				...state,
				global_config_groups_create_loading: action.payload
			}
		case GLOBAL_CONFIG_GROUPS_CREATE_SUCCESS:
			return {
				...state,
				global_config_groups_create_success: action.payload
			}
		case SET_GLOBAL_CONFIG_GROUP_ID:
			return {
				...state,
				global_config_group_id: action.payload
			}
		case GLOBAL_CONFIG_GROUPS_CHANGES:
			return {
				...state,
				global_config_groups_changes: {
					...state.global_config_groups_changes,
					[action.payload.groupId]: action.payload.value
				}
			}
		case GLOBAL_CONFIG_FIELDS_CREATE_LOADING:
			return {
				...state,
				global_config_fields_create_loading: action.payload
			}
		case GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS:
			return {
				...state,
				global_config_fields_create_success: action.payload
			}
		case GLOBAL_CONFIG_ERROR:
		case GLOBAL_CONFIG_CREATE_ERROR:
		case GLOBAL_CONFIG_INFO_ERROR:
		case GLOBAL_CONFIG_GROUPS_ERROR:
		case GLOBAL_CONFIG_GROUPS_CREATE_ERROR:
		case GLOBAL_CONFIG_FIELDS_CREATE_ERROR:
		case GLOBAL_CONFIG_FIELDS_UPDATE_ERROR:
			return {
				...state,
				global_errors: {
					...state.global_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
